import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';
import { mockData } from '../mock';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-gradient-to-br from-lime-50 via-green-50 to-blue-50">
      {/* Decorative Elements */}
      <div className="absolute top-20 right-10 w-72 h-72 bg-lime-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
      <div className="absolute bottom-20 left-10 w-96 h-96 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse" style={{ animationDelay: '2s' }}></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="inline-flex items-center space-x-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full border border-green-200">
              <Sparkles className="w-4 h-4 text-lime-600" />
              <span className="text-sm font-medium text-gray-700">India's Trusted Solar Partner</span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              {mockData.hero.title}
            </h1>
            
            <p className="text-xl text-gray-600 leading-relaxed">
              {mockData.hero.subtitle}
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                onClick={scrollToContact}
                size="lg"
                className="bg-gradient-to-r from-lime-500 to-green-600 hover:from-lime-600 hover:to-green-700 text-white font-semibold px-8 py-6 text-lg transition-all duration-300 hover:scale-105 hover:shadow-xl group"
              >
                {mockData.hero.cta}
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
              <Button
                onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
                size="lg"
                variant="outline"
                className="border-2 border-green-600 text-green-700 hover:bg-green-50 font-semibold px-8 py-6 text-lg transition-all duration-300"
              >
                Our Services
              </Button>
            </div>
            
            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 pt-8">
              <div className="text-center">
                <div className="text-3xl font-bold text-lime-600">500+</div>
                <div className="text-sm text-gray-600 mt-1">Projects</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-green-600">50MW+</div>
                <div className="text-sm text-gray-600 mt-1">Capacity</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600">1000+</div>
                <div className="text-sm text-gray-600 mt-1">Customers</div>
              </div>
            </div>
          </div>
          
          {/* Right Content - Banner Image */}
          <div className="relative hidden lg:block">
            <div className="relative">
              {/* Main banner image */}
              <div className="w-full h-[500px] rounded-3xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500">
                <img 
                  src="/hero-banner.jpg" 
                  alt="Solar Panel Installation" 
                  className="w-full h-full object-cover"
                />
              </div>
              
              {/* Floating cards */}
              <div className="absolute top-10 -left-10 bg-white p-6 rounded-2xl shadow-xl transform hover:scale-110 transition-transform duration-300 z-10">
                <div className="text-3xl font-bold text-green-600">90%</div>
                <div className="text-sm text-gray-600">Cost Savings</div>
              </div>
              
              <div className="absolute bottom-10 -right-10 bg-white p-6 rounded-2xl shadow-xl transform hover:scale-110 transition-transform duration-300 z-10">
                <div className="text-3xl font-bold text-lime-600">25+</div>
                <div className="text-sm text-gray-600">Years Warranty</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
